import * as React from 'react';
import PropTypes from 'prop-types';
var SvgAchievementsTrophy09Small = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 3h-2V2a1 1 0 00-1-1H5a1 1 0 00-1 1v1H2a1 1 0 00-1 1v3c0 2.093 1.43 4 3 4 .045-.006.09-.015.134-.027.624 3.465 3.46 5.819 7.366 6.006V19h-3a1 1 0 00-.894.553l-1 2A1 1 0 007.5 23h9a1 1 0 00.894-1.447l-1-2A1 1 0 0015.5 19h-3v-2.021c3.906-.187 6.742-2.541 7.366-6.006.044.012.089.021.134.027 1.57 0 3-1.907 3-4V4a1 1 0 00-1-1zM4 10c-1 0-2-1.461-2-3V4h2v6zm18-3c0 1.539-1 3-2 3V4h2v3zM11.94 4.13c1.72 0 2.79 1.16 2.79 3.21 0 2.61-.84 3.81-2.66 3.81-1.23 0-2.08-.67-2.4-1.72l1.14-.35c.22.68.63.96 1.26.96.87 0 1.33-.58 1.4-1.88h-.01c-.38.38-.93.59-1.63.59-1.48 0-2.46-.92-2.46-2.29 0-1.36 1.08-2.33 2.57-2.33zm-1.35 2.33c0 .77.53 1.24 1.39 1.24.83 0 1.37-.48 1.37-1.23 0-.73-.56-1.23-1.37-1.23-.86 0-1.39.48-1.39 1.22z"
  }));
});
SvgAchievementsTrophy09Small.defaultProps = {
  height: 24,
  width: 24
};
SvgAchievementsTrophy09Small.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgAchievementsTrophy09Small;